<div class="col-md-12 mt-4">
    <hr/>
    <h5>Bienes Muebles / Inmuebles</h5>
</div>
<div class="row" [formGroup]="form">
    <div formArrayName="assets" *ngFor="let item of getControls(); index as i" class="row">
        <div class="col-md-12 mt-4">
            <h6>Bienes {{i+1}}<button class="btn btn-danger" type="button" style="float: right" (click)="removeRow(i)">X </button></h6>
        </div>
        <div class="col-md-6" *ngFor="let field of formFields" [formGroupName]="i">

            <label class="form-labels mt-4">{{field.title}}</label>
            <div *ngIf="field.type != 'radio'" class="input-group">
                <input [type]="field.type" [formControlName]="field.formControlName" class="form-control">
            </div>
            <div *ngIf="field.type == 'radio'" >
                <div class="form-check form-check-inline">
                    <input type="radio" formControlName="colateral" class="form-check-input" value="si">
                    <label class="form-check-label">Si</label>
                </div>
                <div class="form-check form-check-inline">
                    <input type="radio" formControlName="colateral" class="form-check-input" value="no">
                    <label class="form-check-label">No</label>
                </div>
            </div>

        </div>

    </div>
</div>
<p style="text-align: center;">
<a (click)="addItem()" style="max-width: 150px;" class="btn btn-primary mt-4">+ Añadir Bien</a></p>